/**
 * Tailwind CSS put before APP style, so it doesnt overwrite it all.
 */
import "./styles/main.css"
import "./styles/colors.css"
import "./styles/app.css"

import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import App from "./App"
import { GlobalStoreContextProvider } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import "./i18n"
import { FormStoreContextProvider } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import GlobalOverlayLoader from "components/ProjectNonSpecificComponents/Elements/Loader/GlobalOverlayLoader"
import { HashRouter } from "react-router-dom"
import { PTKMStoreContextProvider } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
const rootElement = document.getElementById("root")

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={<GlobalOverlayLoader active />}>
			<GlobalStoreContextProvider>
				<FormStoreContextProvider>
					<PTKMStoreContextProvider>
						<HashRouter>
							<App />
						</HashRouter>
					</PTKMStoreContextProvider>
				</FormStoreContextProvider>
			</GlobalStoreContextProvider>
		</Suspense>
	</React.StrictMode>,
	rootElement
)
